import { CLOSE_MODAL } from '@iwModals/Modals.actions';
import { RootState } from '@iwProvider/configureStore';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import ChooseDocumentType from './chooseDocumentType/ChooseDocumentType';
import { DocumentUploader } from './documentUploader/DocumentUploader';
import {
    SHOW_UPLOAD_DOCUMENTS_MODAL,
    UPLOAD_DOCUMENT
} from './UploadDocumentsModal.actions';
import { useStateKey } from '../../../iwQueryClient/useStateKey';

const mapStateToProps = ({ uploadDocumentsModal }: RootState) =>
    uploadDocumentsModal;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    closeModal: () => Promise.resolve(dispatch({ type: CLOSE_MODAL })),
    goBackToDocumentTypeSelection: () =>
        dispatch({ type: SHOW_UPLOAD_DOCUMENTS_MODAL }),
    uploadDocument: (
        documents: File[],
        documentType: {
            label: string;
            value: string;
        },
        feedbackIds?: number[] | null,
        applicationId?: string
    ) =>
        dispatch({
            type: UPLOAD_DOCUMENT,
            documents,
            documentType,
            feedbackIds,
            applicationId
        })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const UploadDocumentsModal = (props: PropsFromRedux) => {
    const {
        documentType,
        documentTypes,
        documentData,
        goBackToDocumentTypeSelection,
        closeModal,
        uploadDocument,
        documentsStatus,
        preventBackNavigation,
        feedbackIds,
        applicationId
    } = props;

    const stateKey = useStateKey();

    const queryClient = useQueryClient();
    const { mutate: confirmUpload } = useMutation({
        mutationFn: () => {
            return closeModal();
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['documents', stateKey]);
        }
    });

    if (!documentType) {
        return <ChooseDocumentType documentTypes={documentTypes!} />;
    }

    return (
        <DocumentUploader
            closeModal={confirmUpload}
            goBackToDocumentTypeSelection={goBackToDocumentTypeSelection}
            uploadDocument={uploadDocument}
            documentsStatus={documentsStatus}
            documentType={documentType}
            documentData={documentData}
            preventBackNavigation={preventBackNavigation}
            feedbackIds={feedbackIds}
            applicationId={applicationId}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadDocumentsModal);
